import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Cormorant_Garamond, Jost, Tiro_Devanagari_Hindi } from 'next/font/google'

const sans = Jost({
    subsets: ['latin']
})

const heading = Cormorant_Garamond({
    subsets: ['latin'],
    style: ['normal', 'italic']
})

const devanagari = Tiro_Devanagari_Hindi({
    subsets: ['devanagari'],
    weight: '400',
    preload: false
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:ui-monospace, SFMono-Regular, Menlo, monospace;--font-app-heading:${heading.style.fontFamily};--font-app-devanagari:${devanagari.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
